import { createContext, PropsWithChildren, useCallback, useContext, useState } from "react"
import { api } from "../../contracts";
import { Handout } from "../../contracts/handout/dto";
import { useCourse } from "../course";

type HandoutContextData = {
    list: Handout[],
    current?: Handout,
    getList: () => Promise<Handout[]>,
    changeList: (list: Handout[]) => void,
    changeCurrent: (id: number) => void,
}

const DEFAULT: HandoutContextData = {
    list: [],
    current: undefined,
    getList: () => { return Promise.resolve([]) },
    changeList: () => { },
    changeCurrent: () => { }
}

const HandoutContext = createContext(DEFAULT);

export const HandoutProvider = ({ children }: PropsWithChildren<any>) => {
    const { type } = useCourse();

    const [list, setList] = useState<Handout[]>([]);
    const [current, setCurrent] = useState<Handout>();

    const getList = useCallback(async () => {
        const response = await api.handout.getList(type);
        setList(response);

        return response;
    }, [type]);

    const changeList = useCallback((list: Handout[]) => {
        setList(list);
    }, []);

    const changeCurrent = useCallback((id: number) => {
        setCurrent(list.find(l => l.id === id));
    }, [list]);


    return (
        <HandoutContext.Provider
            value={{
                list,
                current,
                getList,
                changeList,
                changeCurrent
            }}>
            {children}
        </HandoutContext.Provider>
    )
}

export function useHandout(): HandoutContextData {
    const context = useContext(HandoutContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}